import React from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

// Define the interface to match the data structure returned by the contract
interface ReviewType {
  reviewId: number;
  member: string;
  content: string;
  consensus: number;
  consensusType: string;
  creds: number;
  afterConsensus: string;
}

interface ReviewCardProps {
  review: ReviewType;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const navigate = useNavigate();

  // Handle clicks on the Review ID
  const handleReviewIdClick = () => {
    navigate(`/search-results?type=Review&value=${review.reviewId}`);
  };



  return (
    <Card className="mb-3" style={cardStyle}>
      <Card.Header 
        onClick={handleReviewIdClick} 
        style={{ cursor: 'pointer', textDecoration: 'underline', color: '#00bfff' }}
      >
        Review ID: {review.reviewId}
      </Card.Header>
      <Card.Body>
      <Link style={{textDecoration:"none"}} to={`/search-results?type=Member&value=${review.member}`}> <Card.Text><strong>Reviewer:</strong> {review.member}</Card.Text></Link>
        <Card.Text><strong>Consensus Type:</strong> {review.consensusType}</Card.Text>
        <Card.Text><strong>Content:</strong> {review.content}</Card.Text>
        <Card.Text><strong>Creds:</strong> {review.creds}</Card.Text>
        <Card.Text><strong>After Consensus:</strong> {review.afterConsensus}</Card.Text>
      </Card.Body>
    </Card>
  );
};

// Dark theme styling
const cardStyle: React.CSSProperties = {
  backgroundColor: '#1e1e2f',
  color: '#ffffff',
  border: '1px solid #4e4e6b',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
};

export default ReviewCard;
